import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Button, Row, Col, Clearfix } from 'react-bootstrap';
import { injectIntl } from 'react-intl';
import langs from 'langs';

import { getThumbFile } from 'helpers/items';

import EntityStateUpdater from 'component/EntityStateUpdater';

import Loader from 'components/layout/Loader';
import Data from 'components/Data';
import List from 'components/List';
import Entity from 'components/Entity';
import RichEditorContent from 'components/RichEditorContent';

import FormInput from 'components/forms/FormInput';
import FormLanguageSelector from 'components/forms/FormLanguageSelector';
import FormErrors from 'components/forms/FormErrors';

import SelectCmsTemplate from 'components/forms/cms/SelectCmsTemplate';

import { entityMetaMapping } from 'js/constants';

class PageForm extends EntityStateUpdater {
  constructor(props) {
    super(props);

    this.state = {
      entityLoaded: false,
      entityChanged: false,
      showLanguageSelection: false,
      listTemplates: false,
      selectedTemplate: null,
    };

    this.entity = new Entity();
    // if we get page data from the outside, we can pass it on to our data entity
    this.entity.setData(props.page || { language: props.appIntl.locale });
    if (props.meta[entityMetaMapping.page] !== undefined && !props.meta[entityMetaMapping.page].pending) {
      this.entity.setMeta(props.meta, entityMetaMapping.page);

      this.state = {
        ...this.state,
        entityLoaded: true,
        entity: this.entity,
      };
    }
  }

  componentDidUpdate = () => {
    const { meta } = this.props;

    if (
      meta[entityMetaMapping.page] !== undefined &&
      !meta[entityMetaMapping.page].pending &&
      !this.entity.getMetaLoaded()
    ) {
      this.entity.setMeta(meta, entityMetaMapping.page);
      if (this.entity.getDataLoaded()) {
        this.setState({ entityLoaded: true, entity: this.entity });
      }
    }
  };

  showLanguageSelection = e => {
    e.preventDefault();

    this.setState({ showLanguageSelection: true });
  };

  formSubmit = e => {
    e.preventDefault();

    this.setState(
      prevState => ({ entity: prevState.entity.validate() }),
      () => {
        if (this.state.entity.isValid) {
          this.props.onSubmit(this.state.entity.processedData);
        }
      }
    );
  };

  listTemplates = e => {
    e.preventDefault();
    e.stopPropagation();

    this.setState({ listTemplates: true, selectedTemplate: null }, () => {
      const { setModalClassName } = this.props;
      if (setModalClassName) {
        setModalClassName('full-width');
      }
    });
  };

  closeListTemplates = () => {
    this.setState({ listTemplates: false });
  };

  templateSelected = selectedTemplate => {
    this.setState({ selectedTemplate }, () => {
      const { setModalClassName } = this.props;
      const {
        menu_background: menuBackground,
        menu_version: menuVersion,
        logo_version: logoVersion,
        hide_footer: hideFooter,
        content,
      } = selectedTemplate;

      this.updateEntityMultiple(
        ['menuBackground', 'menuVersion', 'logoVersion', 'hideFooter', 'content'],
        [menuBackground, menuVersion, logoVersion, hideFooter, content]
      );

      setModalClassName('');
    });
  };

  updateLanguage = (formName, formValue) => {
    const { selectedTemplate } = this.state;
    if (selectedTemplate) {
      this.updateEntity(formName, formValue, [], this.listTemplates);
    } else {
      this.updateEntity(formName, formValue);
    }
  };

  render() {
    const {
      intl: { messages },
      type,
      formStatus,
      myTemplates,
      publicTemplates,
    } = this.props;
    const { entity, entityChanged, entityLoaded, showLanguageSelection, listTemplates, selectedTemplate } = this.state;

    return (
      <Row>
        <Data dataName="page" /> {/* fetch meta data */}
        <Col xs={12}>
          <FormErrors formStatus={formStatus} />
          {entityLoaded && type === 'new' && (
            <>
              <List
                listName="cmsTemplates"
                url="/api/pagetemplates.json"
                list={myTemplates}
                urlData={{ filters: { owner: '!null', language: entity.getLanguage() } }}
                noRender
                resPerPage={999}
              />
              <List
                listName="publicCmsTemplates"
                url="/api/pagetemplates.json"
                list={publicTemplates}
                urlData={{ filters: { owner: 'null', language: entity.getLanguage() } }}
                noRender
                resPerPage={999}
              />
            </>
          )}

          {!entityLoaded || (type === 'new' && (myTemplates.pending || publicTemplates.pending)) ? (
            <Loader />
          ) : (
            <form method="post" onSubmit={this.formSubmit}>
              <div className="panel panel-transparent">
                <div className="form-group-attached">
                  <FormInput
                    name="name"
                    label={messages.name}
                    value={entity.getName()}
                    meta={entity.getNameMetaInformation()}
                    validation={entity.getNameValidationResult()}
                    onChange={this.updateEntity}
                    disabled={formStatus.pending}
                  />
                  {showLanguageSelection ? (
                    <FormLanguageSelector onChange={this.updateLanguage} value={entity.getLanguage()} />
                  ) : (
                    <div className="form-group form-group-default p-t-10 p-b-10">
                      <a href="#showLanguageSelection" className="text-master" onClick={this.showLanguageSelection}>
                        {messages.edit_language} ({langs.where('1', entity.getLanguage()).local}){' '}
                        <i className="fal fa-chevron-right m-l-10" />
                      </a>
                    </div>
                  )}
                </div>

                {type === 'new' && !listTemplates && (
                  <Clearfix className="m-t-15">
                    <Col xs={6}>
                      <Button block bsSize="lg" active={!listTemplates} onClick={this.closeListTemplates}>
                        <i className="fal fa-file fa-3x m-b-10" />
                        <br /> {messages.create_blank_page}
                      </Button>
                    </Col>
                    <Col xs={6}>
                      <Button block bsSize="lg" active={listTemplates} onClick={this.listTemplates}>
                        <i className="fal fa-cabinet-filing fa-3x m-b-10" />
                        <br /> {messages.create_from_template}
                      </Button>
                    </Col>
                  </Clearfix>
                )}

                {listTemplates && !selectedTemplate && (
                  <SelectCmsTemplate
                    myTemplates={myTemplates}
                    publicTemplates={publicTemplates}
                    onSelect={this.templateSelected}
                  />
                )}

                {!!selectedTemplate && (
                  <div className="m-t-20">
                    <Clearfix>
                      <Col xs={12}>
                        <h4>
                          <a href="#listTemplates" onClick={this.listTemplates}>
                            <i class="fal fa-chevron-left m-r-10" />
                          </a>{' '}
                          {messages.selected_template}
                        </h4>
                      </Col>
                      <Col xs={4} md={3}>
                        {!!selectedTemplate.preview && !!getThumbFile(selectedTemplate.preview) && (
                          <img
                            src={getThumbFile(selectedTemplate.preview).web_link}
                            alt={selectedTemplate.name}
                            className="full-width"
                          />
                        )}
                      </Col>
                      <Col xs={8} md={9}>
                        <h5>{selectedTemplate.name}</h5>
                        <RichEditorContent content={selectedTemplate.description} />
                      </Col>
                    </Clearfix>
                  </div>
                )}

                <div className="text-right m-t-15">
                  <Button
                    bsSize="lg"
                    disabled={formStatus.pending}
                    type="submit"
                    bsStyle={entityChanged ? 'primary' : 'default'}
                  >
                    <i className={'fa-fw ' + (formStatus.pending ? 'fa fa-circle-notch fa-spin' : 'fal fa-save')} />{' '}
                    {type === 'new' && messages.save}
                    {type === 'duplicate' && messages.duplicate}
                  </Button>
                </div>
              </div>
            </form>
          )}
        </Col>
      </Row>
    );
  }
}

const mapStateToProps = state => {
  return {
    appIntl: state.intl,
    meta: state.entityMeta,
    myTemplates: state.list.cmsTemplates,
    publicTemplates: state.list.publicCmsTemplates,
  };
};

export default withRouter(injectIntl(connect(mapStateToProps)(PageForm)));
